/**
 * Handles all trial-related external calls
 */

import Logger from '../helpers/logger';

const log = new Logger();

export default ['$http', function TrialService($http) {
  /**
   * Contacts storeinformation endpoint to get V2-related store info
   *
   * @param tenantId
   */
  this.storeInfo = (tenantId) => {
    const storeConfig = {
      headers: {
        'Content-Type': 'application/json',
        'x-mat-tenant': tenantId
      }
    };

    log.debug({
      category: 'service.trial',
      message: 'storeInfo',
      data: {
        version: 'v2'
      }
    });

    return $http.get(process.env.TRIALS.V2_INFO_URL, storeConfig);
  };

  /**
   * Starts the free trial creation process
   *
   * @param version
   * @param formData
   */
  this.create = (version = 'v1', formData) => {
    return (version === 'v1') ? this._createV1(formData) : this._createV2(formData);
  };

  /**
   * Creates a v1 trial
   *
   * @param formData
   */
  this._createV1 = (formData) => {
    const data = {};

    const createConfig = {
      headers: {
        Auth: process.env.TRIALS.AUTH_HEADER
      }
    };

    data.client_id = process.env.TRIALS.CLIENT_ID;
    data.g_recaptcha_response = formData.recaptcha;
    delete formData.recaptcha;
    data.form_data = formData;

    log.debug({
      category: 'service.trial',
      message: 'create',
      data: {
        version: 'v1'
      }
    });

    return $http.post(process.env.TRIALS.V1_CREATE_URL, data, createConfig);
  };

  /**
   * Creates a v2 trial
   *
   * @param formData
   */
  this._createV2 = (formData) => {
    const data = {};

    data.planId = process.env.TRIALS.PLAN_ID;
    data.firstName = formData.firstName;
    data.lastName = formData.lastName;
    data.expireTrialInFiveMinutes = false;
    data.creditCardToken = '';

    if (formData.userAgent !== undefined && formData.userAgent !== '') {
      data.userAgent = formData.userAgent;
    }

    if (formData.emailAddress !== undefined && formData.emailAddress !== '') {
      data.email = formData.emailAddress;
    }

    if (formData.recaptcha !== undefined && formData.recaptcha !== '') {
      data.recaptcha = formData.recaptcha;
    }

    if (formData.auth0UserId !== undefined && formData.auth0UserId !== '') {
      data.auth0UserId = formData.auth0UserId;
    }

    if (formData.referralCode !== undefined && formData.referralCode !== '') {
      data.referralCode = formData.referralCode;
    }

    if (formData.couponCode !== undefined && formData.couponCode !== '') {
      data.couponCode = formData.couponCode;
    }

    if (formData.phoneNumber !== undefined && formData.phoneNumber !== '') {
      data.phoneNumber = formData.phoneNumber;
    }

    if (formData.password !== undefined && formData.password !== '') {
      data.password = formData.password;
    }

    if (formData.salesforce !== undefined && formData.salesforce !== '') {
      data.salesforce = formData.salesforce;
      data.createSalesforceLead = true;
    }

    log.debug({
      category: 'service.trial',
      message: 'create',
      data: {
        version: 'v2'
      }
    });

    return $http.post(process.env.TRIALS.V2_CREATE_URL, data);
  };

  /**
   * Check to see if a user already has a V2 trial
   *
   * @param email
   */
  this.hasV2Trial = (email) => {
    log.debug({
      category: 'service.trial',
      message: 'hasV2Store'
    });

    return $http.get(process.env.TRIALS.V2_CHECK_URL.replace('{0}', email));
  };
}];
